export default "__VITE_ASSET__SamS166C__"